import React, { Component } from 'react';
import { default as ScheduleWeekCalendar } from '../../../common/ScheduleWeekCalendar';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { SectionContainer } from '../../../common/SectionContainer';
import { default as AgentSchedulesTable } from './AgentSchedulesTable';
import * as actions from '../../redux/schedules_actions';
import moment from 'moment-timezone'

class SupervisorSchedule extends Component {
    constructor(props) {
        super(props);
        if(props.actions.fetchMUsAction) {
            props.actions.fetchMUsAction();
        }

        this.state = {
            StartScheduledDayKey: moment().isoWeekday(1).format('YYYY-MM-DD')
        }
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.StartScheduledDayKey !== nextProps.StartScheduledDayKey) {
            this.setState({
                StartScheduledDayKey: nextProps.StartScheduledDayKey
            })
        }
    }

    render() {
        return (
            <div className="supervisor_schedule">
                <ScheduleWeekCalendar date={this.state.StartScheduledDayKey} />
                <SectionContainer className="agent-schedules-container" titleTextClassName="title" titleText="Agent Schedules">
                <AgentSchedulesTable />
                </SectionContainer>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        MUs: state.schedules.MUs,
        StartScheduledDayKey: state.schedules.selectedStartDate
    };
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch)
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SupervisorSchedule);



// WEBPACK FOOTER //
// ./src/features/schedules/Schedules/SupervisorSchedule/SupervisorSchedule.js